import {
  DTypeMainHead,
  DTypeCardView,
  FUNERAL_SIDO,
  FUNERAL_SIGUNGU,
  colors,
  ATypeMap,
  GOI_WEB_URL,
  ATypeBreadCrumb,
  FullWidthButton,
} from "goi_common";
import { GetStaticPaths, GetStaticProps } from "next";

import React from "react";
import { ParlorDetailProps } from "goi_common";
import { parlorRegion } from "@/constants/parlorRegion";
import { Box, Stack } from "@mui/material";
import Head from "next/head";
import facilities from "goi_common/src/constants/facilities_detail.json";

const { regionColor, targetSidos } = parlorRegion;

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = facilities
    .filter((f) => targetSidos.includes(f.sido) && f.is_public)
    .map((f) => ({
      params: {
        companyname: "기초생활수급자 공설장지 " + f.companyname,
      },
    }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const code = params?.companyname as string;
  const companyname = code.replace("기초생활수급자 공설장지 ", "");
  let p_facility;
  let district;
  let name = "";
  let description = "";

  if (companyname) {
    p_facility = facilities.find((f) => f.companyname === companyname);
    if (p_facility) {
      name = p_facility.companyname;

      district = p_facility.address.slice(0, 2);
      if (p_facility.address.split(" ")[0].length == 4)
        district = p_facility.address[0] + p_facility.address[2];

      description = `${p_facility.companyname} 기초생활수급자는 화장 비용 어떻게 될까? ${p_facility.address}`;
    }
  }

  return {
    props: {
      defaultPFacility: p_facility,
      pageDescription: description,
      pageKeywords: `${p_facility?.companyname}, ${p_facility?.companyname} 기초생활수급자, ${district} 기초생활수급자 장례, 장제비, 장제급여, 기초생활수급자 장례 얼마,`,
      pageOgTitle: `기초생활 보호 대상자를 위한 화장 비용 안내 (${p_facility?.companyname})::  전라광주장례추천포털`,
      pageOgDescription: description,
      pageOgImage: p_facility?.images[0].url || "",
      hasError: !p_facility,
    },
  };
};

export default function companyname({
  defaultPFacility,
  pageOgTitle,
}: {
  defaultPFacility: ParlorDetailProps;
  pageOgTitle: string;
}) {
  const regionPFacilities = facilities.filter((p) =>
    targetSidos.includes(String(p.sido)) && p.is_public
  );
  const sidoName = FUNERAL_SIDO.get(Number(defaultPFacility.sido));
  const sigunguName = FUNERAL_SIGUNGU.get(Number(defaultPFacility.sido))?.get(
    Number(defaultPFacility.sigungu)
  );
  const carouselItems = regionPFacilities.map((res, i) => {
    return {
      "@type": "ListItem",
      name: `(비용안내) ${res.companyname}`,
      image: `${res.images[0].url}`,
      url: `https://www.honam-funeralcenter.co.kr/free-benefit/free-facility/${res.companyname} 기초생활수급자 안내`,
      position: i + 1,
    };
  });

  const carouselRichSearch =
    regionPFacilities.length > 6
      ? {
          "@context": "http://schema.org",
          "@type": "ItemList",
          itemListElement: carouselItems,
        }
      : {};
  return (
    <Stack>
      <Head>
        <title>{pageOgTitle}</title>
        {regionPFacilities.length > 5 && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(carouselRichSearch),
            }}
          />
        )}
      </Head>
      <ATypeBreadCrumb
        firstItem={{
          text: `기초수급자장례 추천`,
          href: `${GOI_WEB_URL}?utm_source=dogsound` + "/match/request/?utm_source=dogsound",
          event: {
            domain: "honam",
            path: "fr_facility",
            trigger_and_target: "br_crumb_mth_req",
          },
        }}
        secondItem={{
          text: `기초생활수급자 장례114`,
          href: `/free-benefit/`,
          event: {
            domain: "honam",
            path: "fr_facility",
            trigger_and_target: "br_crumb_fr_benef",
          },
        }}
        goiHomeEvent={{
          domain: "honam",
          path: "fr_facility",
          trigger_and_target: "br_crumb_goi_home",
        }}
      />
      <DTypeMainHead
        sidoName={sidoName}
        sigunguName={sigunguName}
        mainColor={regionColor}
        defaultParlor={defaultPFacility}
        title={`${defaultPFacility.companyname}`}
        managed_type={defaultPFacility.managed_type}
        isJangji
      />

      <Stack padding="20px">
        <Box width="100%" height="1px" style={{ background: "black" }} />
      </Stack>
      <Stack
        className="body_16_m"
        style={{
          background: colors.gray50,
          padding: "12px 14px",
          margin: "0 20px",
        }}
      >
        기초생활수급자는 화장 비용이 전액 감면됩니다.
      </Stack>

      <Stack padding="18px 20px 40px" gap="40px">
        <Box className="body_14_m">
          e-하늘장사정보시스템에서 가져온 정보이며, 자세한 안치 대상 여부를
          알아보려면 상담이 필요합니다.
        </Box>
        <FullWidthButton
          text="바로 상담하기"
          href="tel:1666-9784"
          backgroundColor={regionColor.c400}
        />
      </Stack>
      <Stack padding="20px">
        <Box width="100%" height="1px" style={{ background: "black" }} />
      </Stack>
      <Stack padding="40px 20px" marginBottom="40px" gap="8px">
        <ATypeMap defaultParlor={defaultPFacility} />
      </Stack>

      <Stack padding="24px 16px 10px" gap="12px">
        <h3 className="subtitle_18_b">전라 광주 기초생활수급자 장지</h3>
        {regionPFacilities.map((res) => (
          <DTypeCardView
            address={res.address}
            // descriptions={["기초생활수급자 무료"]}
            descriptions={[""]}
            key={res.companyname}
            name={res.companyname}
            href={`/free-benefit/free-facility/기초생활수급자 공설장지 ${res.companyname}/`}
            imgSrc={res.images[0]?.url ? res.images[0].url : ""}
          />
        ))}
      </Stack>
    </Stack>
  );
}
